import React from "react";
import { useTranslation } from 'react-i18next';
import { ImportantDate } from "./important-date";



export const AmberEvent = (props) => {
    const {date} = props;
    const {t} = useTranslation();
    return (
        <p style={{margin: 0}}>{ t( 'home.teaser-text-live-event' ) } - <ImportantDate text={date} /></p>
    );
};